export default (currentPoint: number, targetPoint: number) => {
  const [left, right] = [targetPoint - 75, targetPoint + 75];
  return currentPoint >= left && currentPoint <= right;
};
